import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { EnvironmentCmsUrls } from '@core/domain/types/environment-config.types';
import { ConfigService } from '@core/services/config/config.service';
import { AssetsSharedService } from '@features/cms-render/ui/services/assets-shared/assets-shared.service';

@Component({
    selector: 'slice-flex-close',
    templateUrl: './slice-flex-close.component.html',
    styleUrls: ['./slice-flex-close.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliceFlexCloseComponent implements OnInit {
    @Input() public closeSectionData: {
        closeSectionType?: string;
        closeSectionText?: string;
        closeSectionCustomImage?: {
            image: string;
            width: number;
            height: number;
        };
    } = {};

    @Output() public readonly deleteSlice = new EventEmitter();

    public imageSrc: { src: string; title: string };

    constructor(
        private readonly configService: ConfigService,
        private readonly assetsSharedService: AssetsSharedService,
    ) {
    }

    public ngOnInit(): void {
        if (this.closeSectionData.closeSectionType === 'custom') {
            const assetsUrl = `${this.configService.getConfigUrl<EnvironmentCmsUrls>('cmsUrls').content}/assets/`;
            const imageUrl: string = this.closeSectionData.closeSectionCustomImage.image;
            const imageName = imageUrl?.split('/')?.pop();
            const src = this.assetsSharedService.getAssetUrl(imageUrl, assetsUrl);
            this.imageSrc = {
                src: src,
                title: imageName?.split('.')?.slice(0, -1)?.join('.'),
            };
        }
    }

    public close() {
        this.deleteSlice.emit();
    }
}
